import React from "react";
import { ImageComponent } from "../ImageComponent/ImageComponent";
import ReactPortalComp from "../ReactPortalComp";
import {
  ModalWrapperCloseButton,
  ModalWrapperContainer,
  ModalWrapperOverlay,
} from "./ModalWrapper.style";

interface ModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  customWidth?: string;
}

export const ModalWrapper: React.FC<ModalWrapperProps> = ({
  isOpen,
  onClose,
  children,
  customWidth = "500px",
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <ReactPortalComp>
      <ModalWrapperOverlay onClick={handleOverlayClick}>
        <ModalWrapperContainer customWidth={customWidth}>
          <ModalWrapperCloseButton onClick={onClose}>
            <ImageComponent
              src="https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg"
              width="20px"
              height="20px"
              alt="Close"
            />
          </ModalWrapperCloseButton>
          {children}
        </ModalWrapperContainer>
      </ModalWrapperOverlay>
    </ReactPortalComp>
  );
};

export default ModalWrapper;
